import { createFileRoute } from "@tanstack/react-router";
import { Step1 } from "~/components/betaling-instellen";

export const Route = createFileRoute("/(authenticated)/uitbetaling-instellen/")({
  component: Step1,
});
